import { render } from "./Help-Center.vue?vue&type=template&id=2efe37a8&scoped=true"
import script from "./Help-Center.vue?vue&type=script&lang=js"
export * from "./Help-Center.vue?vue&type=script&lang=js"

import "./Help-Center.vue?vue&type=style&index=0&id=2efe37a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2efe37a8"]])

export default __exports__